exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".onboarding-list-business-unit .content-client-list{position:relative}.onboarding-list-business-unit .content-list-table{margin-top:60px}.onboarding-list-business-unit.mobile .header-filter-components{margin:30px 0 0 0}.onboarding-list-business-unit.mobile .content-list-table{margin-top:10px}", ""]);

// exports
